import * as types from '../constants/gear';

export const clearInstanceDetails = response => ({
  type: types.CLEAR_INSTANCE_DETAILS,
});

// TESTING
export const resetAllGears = () => ({
  type: types.API_RESET_ALL_GEARS,
});

export const apiGetAllOrgRobotsRequest = (token, organisationId) => ({
  type: types.API_GET_ALL_ORG_ROBOTS_REQUEST,
  token,
  organisationId,
});
export const apiGetAllOrgRobotsSuccess = response => ({
  type: types.API_GET_ALL_ORG_ROBOTS_SUCCESS,
  response,
});
export const apiGetAllOrgRobotsFailed = response => ({
  type: types.API_GET_ALL_ORG_ROBOTS_FAILED,
  response,
});

// Bulk onboarding (multiple robots in one request)
export const apiBulkOnboardOrgRobotRequest = (token, payload) => ({
  type: types.API_BULK_ONBOARD_ORG_ROBOT_REQUEST,
  token,
  payload,
});
export const apiBulkOnboardOrgRobotSuccess = response => ({
  type: types.API_BULK_ONBOARD_ORG_ROBOT_SUCCESS,
  payload: response,
});
export const apiBulkOnboardOrgRobotFailed = error => ({
  type: types.API_BULK_ONBOARD_ORG_ROBOT_FAILED,
  payload: error,
});
export const apiClearBulkOnboardResult = () => ({
  type: types.API_CLEAR_BULK_ONBOARD_RESULT,
});

// Per-air_id claimability check for the multi-robot onboarding list; keyed by air_id.
export const apiValidateRobotAirIdRequest = (token, airId) => ({
  type: types.API_VALIDATE_ROBOT_AIR_ID_REQUEST,
  token,
  airId,
});
export const apiValidateRobotAirIdSuccess = (payload, airId) => ({
  type: types.API_VALIDATE_ROBOT_AIR_ID_SUCCESS,
  payload,
  airId,
});
export const apiValidateRobotAirIdFailed = (payload, airId) => ({
  type: types.API_VALIDATE_ROBOT_AIR_ID_FAILED,
  payload,
  airId,
});
export const apiClearRobotAirIdValidation = () => ({
  type: types.API_CLEAR_ROBOT_AIR_ID_VALIDATION,
});

export const apiUpdateOrgRobotRequest = (token, robotData) => ({
  type: types.API_UPDATE_ORG_ROBOT_REQUEST,
  token,
  robotData,
});
export const apiUpdateOrgRobotSuccess = response => ({
  type: types.API_UPDATE_ORG_ROBOT_SUCCESS,
  response,
});
export const apiUpdateOrgRobotFailed = response => ({
  type: types.API_UPDATE_ORG_ROBOT_FAILED,
  response,
});

export const apiCreateShootRobotRequest = (token, robotData) => ({
  type: types.API_CREATE_SHOOT_ROBOT_REQUEST,
  token,
  robotData,
});
export const apiCreateShootRobotSuccess = response => ({
  type: types.API_CREATE_SHOOT_ROBOT_SUCCESS,
  response,
});
export const apiCreateShootRobotFailed = response => ({
  type: types.API_CREATE_SHOOT_ROBOT_SUCCESS,
  response,
});

export const apiGetAllShootRobotsRequest = (token, projectId) => ({
  type: types.API_GET_ALL_SHOOT_ROBOT_REQUEST,
  token,
  projectId,
});
export const apiGetAllShootRobotsSuccess = response => ({
  type: types.API_GET_ALL_SHOOT_ROBOT_SUCCESS,
  response,
});
export const apiGetAllShootRobotsFailed = response => ({
  type: types.API_GET_ALL_SHOOT_ROBOT_FAILED,
  response,
});

export const apiUpdateShootRobotRequest = (token, robotId, updateData) => ({
  type: types.API_UPDATE_SHOOT_ROBOT_REQUEST,
  token,
  robotId,
  updateData,
});
export const apiUpdateShootRobotSuccess = response => ({
  type: types.API_UPDATE_SHOOT_ROBOT_SUCCESS,
  response,
});
export const apiUpdateShootRobotFailed = response => ({
  type: types.API_UPDATE_SHOOT_ROBOT_FAILED,
  response,
});

export const apiDeleteShootRobotRequest = (token, robotId) => ({
  type: types.API_DELETE_SHOOT_ROBOT_REQUEST,
  token,
  robotId,
});
export const apiDeleteShootRobotSuccess = response => ({
  type: types.API_DELETE_SHOOT_ROBOT_SUCCESS,
  response,
});
export const apiDeleteShootRobotFailed = response => ({
  type: types.API_DELETE_SHOOT_ROBOT_FAILED,
  response,
});

export const apiClearAllShootRobotsRequest = () => ({
  type: types.API_CLEAR_ALL_SHOOT_ROBOTS_REQUEST,
});

export const apiGetAllOrgInstanceRequest = (token, organisationId) => ({
  type: types.API_GET_ALL_ORG_INSTANCE_REQUEST,
  token,
  organisationId,
});
export const apiGetAllOrgInstanceSuccess = response => ({
  type: types.API_GET_ALL_ORG_INSTANCE_SUCCESS,
  response,
});
export const apiGetAllOrgInstanceFailed = response => ({
  type: types.API_GET_ALL_ORG_INSTANCE_FAILED,
  response,
});

export const apiOnboardOrgInstanceRequest = (token, instanceData) => ({
  type: types.API_ONBOARD_ORG_INSTANCE_REQUEST,
  token,
  instanceData,
});
export const apiOnboardOrgInstanceSuccess = response => ({
  type: types.API_ONBOARD_ORG_INSTANCE_SUCCESS,
  response,
});
export const apiOnboardOrgInstanceFailed = response => ({
  type: types.API_ONBOARD_ORG_INSTANCE_FAILED,
  response,
});

export const apiUpdateOrgInstanceRequest = (token, instanceData) => ({
  type: types.API_UPDATE_ORG_INSTANCE_REQUEST,
  token,
  instanceData,
});
export const apiUpdateOrgInstanceSuccess = response => ({
  type: types.API_UPDATE_ORG_INSTANCE_SUCCESS,
  response,
});
export const apiUpdateOrgInstanceFailed = response => ({
  type: types.API_UPDATE_ORG_INSTANCE_FAILED,
  response,
});

export const apiCreateShootInstanceRequest = (token, instanceData) => ({
  type: types.API_CREATE_SHOOT_INSTANCE_REQUEST,
  token,
  instanceData,
});
export const apiCreateShootInstanceSuccess = response => ({
  type: types.API_CREATE_SHOOT_INSTANCE_SUCCESS,
  response,
});
export const apiCreateShootInstanceFailed = response => ({
  type: types.API_CREATE_SHOOT_INSTANCE_SUCCESS,
  response,
});

export const apiGetAllShootInstanceRequest = (token, projectId) => ({
  type: types.API_GET_ALL_SHOOT_INSTANCE_REQUEST,
  token,
  projectId,
});
export const apiGetAllShootInstanceSuccess = response => ({
  type: types.API_GET_ALL_SHOOT_INSTANCE_SUCCESS,
  response,
});
export const apiGetAllShootInstanceFailed = response => ({
  type: types.API_GET_ALL_SHOOT_INSTANCE_FAILED,
  response,
});

export const apiUpdateShootInstanceRequest = (token, instanceId, updateData) => ({
  type: types.API_UPDATE_SHOOT_INSTANCE_REQUEST,
  token,
  instanceId,
  updateData,
});
export const apiUpdateShootInstanceSuccess = response => ({
  type: types.API_UPDATE_SHOOT_INSTANCE_SUCCESS,
  response,
});
export const apiUpdateShootInstanceFailed = response => ({
  type: types.API_UPDATE_SHOOT_INSTANCE_FAILED,
  response,
});

export const apiDeleteShootInstanceRequest = (token, instanceId) => ({
  type: types.API_DELETE_SHOOT_INSTANCE_REQUEST,
  token,
  instanceId,
});
export const apiDeleteShootInstanceSuccess = response => ({
  type: types.API_DELETE_SHOOT_INSTANCE_SUCCESS,
  response,
});
export const apiDeleteShootInstanceFailed = response => ({
  type: types.API_DELETE_SHOOT_INSTANCE_FAILED,
  response,
});

export const apiGetAllShootInstancesLiveStatusRequest = (token, instancesArr) => ({
  type: types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_REQUEST,
  token,
  instancesArr, // Array of arrays: instance region, value: instance's air_id (instance aws id)
});
export const apiGetAllShootInstancesLiveStatusSuccess = response => ({
  type: types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_SUCCESS,
  response,
});
export const apiGetAllShootInstancesLiveStatusFailed = error => ({
  type: types.API_GET_ALL_SHOOT_INSTANCES_LIVE_STATUS_FAILED,
  error: {
    message: error.response?.data?.error,
    status: error.response?.status,
  },
});

export const apiGetShootInstanceLiveStatusRequest = (token, instanceAirId, instanceRegion) => ({
  type: types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_REQUEST,
  token,
  instanceAirId,
  instanceRegion,
});
export const apiGetShootInstanceLiveStatusSuccess = response => ({
  type: types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_SUCCESS,
  response,
});
export const apiGetShootInstanceLiveStatusFailed = error => ({
  type: types.API_GET_SHOOT_INSTANCE_LIVE_STATUS_FAILED,
  error: {
    message: error.response?.data?.error,
    status: error.response?.status,
  },
});

export const apiStartShootInstanceRequest = (token, instanceData) => ({
  type: types.API_START_SHOOT_INSTANCE_REQUEST,
  token,
  instanceData,
});
export const apiStartShootInstanceSuccess = response => ({
  type: types.API_START_SHOOT_INSTANCE_SUCCESS,
  response,
});
export const apiStartShootInstanceFailed = error => ({
  type: types.API_START_SHOOT_INSTANCE_FAILED,
  error: {
    message: error.response?.data?.error, // The "response" is from Axios error object
    status: error.response?.status,
  },
});

export const apiStopShootInstanceRequest = (token, instanceData) => ({
  type: types.API_STOP_SHOOT_INSTANCE_REQUEST,
  token,
  instanceData,
});
export const apiStopShootInstanceSuccess = response => ({
  type: types.API_STOP_SHOOT_INSTANCE_SUCCESS,
  response,
});
export const apiStopShootInstanceFailed = error => ({
  type: types.API_STOP_SHOOT_INSTANCE_FAILED,
  error: {
    message: error.response?.data?.error, // The "response" is from Axios error object
    status: error.response?.status,
  },
});

export const apiUpdateRobotZCamSingleSettingRequest = (token, robotName, payload) => ({
  type: types.API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_REQUEST,
  token: token,
  robotName: robotName,
  payload: payload,
});
export const apiUpdateRobotZCamSingleSettingSuccess = response => ({
  type: types.API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_SUCCESS,
  payload: response,
});
export const apiUpdateRobotZCamSingleSettingFailed = error => ({
  type: types.API_UPDATE_ROBOT_ZCAM_SINGLE_SETTING_FAILED,
  payload: error
});

export const apiGetInventoryOnPremServerInfoRequest = (token, airId) => ({
  type: types.API_GET_INVENTORY_ON_PREM_SERVER_INFO_REQUEST,
  token: token,
  airId: airId,
});

export const apiGetInventoryOnPremServerInfoSuccess = (payload) => ({
  type: types.API_GET_INVENTORY_ON_PREM_SERVER_INFO_SUCCESS,
  payload: payload,
});

export const apiClearInventoryOnPremServerInfoRequest = () => ({
  type: types.API_CLEAR_INVENTORY_ON_PREM_SERVER_REQUEST,
});

export const apiOnboardOrgOnPremServerRequest = (token, onboardData) => ({
  type: types.API_ONBOARD_ORG_ON_PREM_SERVER_REQUEST,
  token: token,
  onboardData: onboardData,
});
export const apiOnboardOrgOnPremServerSuccess = (payload) => ({
  type: types.API_ONBOARD_ORG_ON_PREM_SERVER_SUCCESS,
  payload: payload,
});
export const apiOnboardOrgOnPremServerFailed = (payload) => ({
  type: types.API_ONBOARD_ORG_ON_PREM_SERVER_FAILED,
  payload: payload,
});

export const apiUpdateOrgOnPremServerRequest = (token, updateData) => ({
  type: types.API_UPDATE_ORG_ON_PREM_SERVER_REQUEST,
  token: token,
  updateData: updateData,
});
export const apiUpdateOrgOnPremServerSuccess = (payload) => ({
  type: types.API_UPDATE_ORG_ON_PREM_SERVER_SUCCESS,
  payload: payload,
});
export const apiUpdateOrgOnPremServerFailed = (payload) => ({
  type: types.API_UPDATE_ORG_ON_PREM_SERVER_FAILED,
  payload: payload,
});

export const apiGetAllOrgOnPremServersRequest = (token, organizationId) => ({
  type: types.API_GET_ALL_ORG_ON_PREM_SERVERS_REQUEST,
  token: token,
  organizationId: organizationId,
});
export const apiGetAllOrgOnPremServersSuccess = (payload) => ({
  type: types.API_GET_ALL_ORG_ON_PREM_SERVERS_SUCCESS,
  payload: payload,
});
export const apiGetAllOrgOnPremServersFailed = (payload) => ({
  type: types.API_GET_ALL_ORG_ON_PREM_SERVERS_FAILED,
  payload: payload,
});
